import {GlobalState} from "../utils/store";

export const briefStore = new GlobalState(null);
